import ServiceBase from '../ServiceBase';

export default class PollsAdminService extends ServiceBase {

    getPolls(projectID) {
        return this.request('get', 'admin/polls/getPolls', {
            projectID,
        });
    }

    getPoll(pollID) {
        return this.request('get', 'admin/polls/getPoll', {
            pollID,
        });
    }

    deletePoll(pollID, projectID) {
        return this.request('post', 'admin/polls/deletePoll', {
            projectID,
            pollID,
        });
    }

    createPoll(poll, projectID) {
        return this.request('post', 'admin/polls/createPoll', {
            projectID,
            ...poll,
        });
    }

    updatePoll(poll, projectID) {
        return this.request('post', 'admin/polls/updatePoll', {
            projectID,
            ...poll,
        });
    }
}
